// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2668fbcc","879":"a745fbe7"}[chunkId] + ".chunk.js";
};